import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import type { FormValues } from '#src/pages/manage/security-breach/SecurityBreach.tsx';

export const SaveFormValues = ({ children }: { children: React.ReactNode }) => {
  const { watch } = useFormContext<FormValues>();
  useEffect(() => {
    const { unsubscribe } = watch((value) => {
      localStorage.setItem('securityBreachFormValues', JSON.stringify(value));
    });
    return () => unsubscribe();
  }, [watch]);

  return children;
};
